// Configuración de la aplicación
export const appConfig = {
  // URL base de la API
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
  
  // Entorno actual
  environment: import.meta.env.MODE || 'development',
  
  // Otras configuraciones
  appName: 'Upload From',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
};

// Función para mostrar la configuración en consola
export const logAppConfig = () => {
  // Logging disabled for production
  // console.log('\n🌐 ===== CONFIGURACIÓN DEL CLIENTE =====');
  // console.log(`📱 Aplicación: ${appConfig.appName} v${appConfig.version}`);
  // console.log(`📊 Entorno: ${appConfig.environment}`);
  // console.log(`🔗 API Base URL: ${appConfig.apiBaseUrl}`);
  // console.log(`🌍 URL Actual: ${window.location.origin}`);
  // console.log(`📍 Ruta Actual: ${window.location.pathname}`);
  // console.log('==========================================\n');
};

// Función para mostrar configuración de mapeo
export const logMappingConfig = (_config: any) => {
  // Logging disabled for production
  // console.log('\n🗺️  ===== CONFIGURACIÓN DE MAPEO =====');
  // console.log(`📋 Nombre: ${config.name}`);
  // console.log(`📝 Descripción: ${config.description}`);
  // console.log(`📄 Archivo Excel: ${config.excelFileName}`);
  // console.log(`🆔 ID: ${config.id}`);
  // console.log(`✅ Activo: ${config.isActive ? 'Sí' : 'No'}`);
  // console.log(`⭐ Por defecto: ${config.isDefault ? 'Sí' : 'No'}`);
  // console.log(`🔢 Campos configurados: ${config.fields?.length || 0}`);
  
  // if (config.fields && config.fields.length > 0) {
  //   console.log('📋 Campos:');
  //   config.fields.forEach((field: any, index: number) => {
  //     console.log(`  ${index + 1}. ${field.targetFieldLabel} (${field.targetField})`);
  //     console.log(`     - Columna Excel: ${field.excelColumn || 'No configurada'}`);
  //     console.log(`     - Requerido: ${field.isRequired ? 'Sí' : 'No'}`);
  //   });
  // }
  // console.log('==========================================\n');
};

// Función para mostrar URLs de procesamiento
export const logProcessingUrls = (_config: any) => {
  // Logging disabled for production
  // console.log('\n⚙️  ===== URLs DE PROCESAMIENTO =====');
  // console.log(`🔗 API Backend: ${appConfig.apiBaseUrl}`);
  // console.log(`📤 Endpoint Interno: ${appConfig.apiBaseUrl}/upload/excel`);
  // console.log(`🌐 Servicio Externo: Se enviará al servicio configurado en el backend`);
  // console.log(`🗺️  Configuración ID: ${config.id}`);
  // console.log(`📋 Configuración: ${config.name}`);
  // console.log(`📄 Archivo Excel: ${config.excelFileName}`);
  // console.log('==========================================\n');
};
